import { render, staticRenderFns } from "./littletabs.vue?vue&type=template&id=5b842f60"
import script from "./littletabs.vue?vue&type=script&lang=js"
export * from "./littletabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports